import React, {
	useEffect,
} from 'react';

import { useAllSelector } from '../../services/selectors/allSelector';

export const RoutePharmacistModal = ({
	handleRouteChange,
	selectedRoute,
	placeholder = 'Select Pharmacist' }) => {

	const { routeListResponse } = useAllSelector()

	var routeList = routeListResponse

	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	return (
		<React.Fragment>

			<form>


				<div className="relative form-group mb-4">
					<div className="relative">
						<div
							className="absolute top-3 pl-2 start-0 flex items-center ps-3.5 pointer-events-none">
							<svg width="20" height="21" viewBox="0 0 20 21" fill="none"
								xmlns="http://www.w3.org/2000/svg">
								<g opacity="0.5">
									<path
										d="M14.1667 13.8333C13.4722 13.8333 12.8819 13.5903 12.3958 13.1042C11.9097 12.6181 11.6667 12.0278 11.6667 11.3333C11.6667 10.6389 11.9097 10.0486 12.3958 9.5625C12.8819 9.07639 13.4722 8.83333 14.1667 8.83333C14.8611 8.83333 15.4514 9.07639 15.9375 9.5625C16.4236 10.0486 16.6667 10.6389 16.6667 11.3333C16.6667 12.0278 16.4236 12.6181 15.9375 13.1042C15.4514 13.5903 14.8611 13.8333 14.1667 13.8333ZM7.5 17.25V18H4.16667C3.70833 18 3.31597 17.8368 2.98958 17.5104C2.66319 17.184 2.5 16.7917 2.5 16.3333V4.66667C2.5 4.20833 2.66319 3.81597 2.98958 3.48958C3.31597 3.16319 3.70833 3 4.16667 3H15.8333C16.2917 3 16.684 3.16319 17.0104 3.48958C17.3368 3.81597 17.5 4.20833 17.5 4.66667V8.83333C17.0694 8.29167 16.5833 7.87847 16.0417 7.59375C15.5 7.30903 14.875 7.16667 14.1667 7.16667C14.1667 6.93056 14.0868 6.73264 13.9271 6.57292C13.7674 6.41319 13.5694 6.33333 13.3333 6.33333H6.66667C6.43056 6.33333 6.23264 6.41319 6.07292 6.57292C5.91319 6.73264 5.83333 6.93056 5.83333 7.16667C5.83333 7.40278 5.91319 7.60069 6.07292 7.76042C6.23264 7.92014 6.43056 8 6.66667 8H11.6667C11.3889 8.22222 11.1389 8.47222 10.9167 8.75C10.6944 9.02778 10.5069 9.33333 10.3542 9.66667H6.66667C6.43056 9.66667 6.23264 9.74653 6.07292 9.90625C5.91319 10.066 5.83333 10.2639 5.83333 10.5C5.83333 10.7361 5.91319 10.934 6.07292 11.0937C6.23264 11.2535 6.43056 11.3333 6.66667 11.3333H10C10 11.625 10.0312 11.9097 10.0937 12.1875C10.1562 12.4653 10.2431 12.7361 10.3542 13H6.66667C6.43056 13 6.23264 13.0799 6.07292 13.2396C5.91319 13.3993 5.83333 13.5972 5.83333 13.8333C5.83333 14.0694 5.91319 14.2674 6.07292 14.4271C6.23264 14.5868 6.43056 14.6667 6.66667 14.6667H8.70833C8.33333 14.9861 8.03819 15.3715 7.82292 15.8229C7.60764 16.2743 7.5 16.75 7.5 17.25ZM10 19.6667C9.76389 19.6667 9.56597 19.5868 9.40625 19.4271C9.24653 19.2674 9.16667 19.0694 9.16667 18.8333V17.25C9.16667 16.9583 9.23611 16.684 9.375 16.4271C9.51389 16.1701 9.70833 15.9653 9.95833 15.8125C10.4028 15.5486 10.7778 15.3646 11.0833 15.2604C11.3889 15.1562 11.7986 15.0625 12.3125 14.9792C12.4792 14.9514 12.6458 14.9549 12.8125 14.9896C12.9792 15.0243 13.1181 15.1042 13.2292 15.2292L14.1667 16.3333L15.0833 15.2292C15.1944 15.0903 15.3333 15.0069 15.5 14.9792C15.6667 14.9514 15.8333 14.9514 16 14.9792C16.5139 15.0625 16.9236 15.1562 17.2292 15.2604C17.5347 15.3646 17.9097 15.5486 18.3542 15.8125C18.6042 15.9653 18.8021 16.1701 18.9479 16.4271C19.0937 16.684 19.1667 16.9583 19.1667 17.25V18.8333C19.1667 19.0694 19.0868 19.2674 18.9271 19.4271C18.7674 19.5868 18.5694 19.6667 18.3333 19.6667H10Z"
										fill="#1B2336" />
								</g>
							</svg>
						</div>

						{/* <select id="route" value={selectedRoute} onChange={handleRouteChange} name="route"
							className="bg-gray-50 pl-10 border-gray-300 text-gray-500 text-sm rounded-lg block w-full ps-10 p-2.5"
							placeholder="Select Route" required style={{ height: '50px' }}>

							<option value="" disabled>{placeholder}</option>

							{routeList?.length === 0 ? null :
								<>
									{routeList?.map((value, index) => (
										<React.Fragment key={index}>
											<option value={value}>{value}</option>
										</React.Fragment>
									))}
								</>
							}
						</select> */}

						<select
							id="route"
							value={routeList?.includes(selectedRoute) ? selectedRoute : ""}
							onChange={handleRouteChange}
							name="route"
							className="bg-gray-50 pl-10 border-gray-300 text-gray-500 text-sm rounded-lg block w-full ps-10 p-2.5"
							placeholder="Select Route"
							required
							style={{ height: '50px' }}
						>
							<option value="" disabled>{placeholder}</option>
							{routeList?.length > 0 &&
								routeList.map((value, index) => (
									<option key={index} value={value}>{value}</option>
								))
							}
						</select>

					</div>
				</div>

			</form>
		</React.Fragment>
	)
}
